module.exports = __webpack_public_path__ + "assets/en-GB.b12f4e5b.png";